import React from 'react';
import PropTypes from 'prop-types';
import { Loading } from 'carbon-components-react';

import './loading.scss';

const LoadingSpinner = (props) => {
    return <div className='ht-loading-holder'>
        <Loading {...props} className='ht-loading' />
    </div>;
};

LoadingSpinner.defaultProps = {
    withOverlay: false
};

LoadingSpinner.propTypes = {
    withOverlay: PropTypes.bool
};

export default LoadingSpinner;
